import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { MarketingFlow } from "../../marketing.types";
import { requestGetMarketingFlows } from "./getMarketingFlows.request";

const useMarketingFlows = (
  options?: QueryOptions<MarketingFlow[], ApiServiceError<ApiError>>
) => {
  const { data: flows, ...rest } = useQuery({
    queryKey: ["marketing", "flows", "list"],
    queryFn: requestGetMarketingFlows,
    onError: toastServerError,
    ...options
  });

  return { flows: flows ?? [], ...rest };
};

export default useMarketingFlows;
